var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"route-register\"><section class=\"extra-padding\"><container><div class=\"prose text-center\"><h1>Create an Opendoor account</h1><p class=\"text-muted\">And get the most out of Opendoor services</p></div><od-signup on-registration-complete=\"registerCtrl.redirectToHome()\" buyer-type=\"seller\"></od-signup></container></section></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/routes/humans/register.jade
 ** module id = 3564
 ** module chunks = 3
 **/